import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}stockItem/${COMMON_QUERY_PARAMS.STOCK_ITEM_ID}`;

export interface GetStockItemQueryArgs {
  stockItemId: string;
}

export interface StockItemSummaryDto {
  stockItemId: string;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const getStockItemRequest = (
  payload: GetStockItemQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.STOCK_ITEM_ID, payload.stockItemId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getStockItemQuery = async (
  payload: GetStockItemQueryArgs,
): Promise<BackResponse<StockItemSummaryDto> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<StockItemSummaryDto>>(
      getStockItemRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
